import { css } from 'styled-components'

export const quickApplyModalStyled = css`
	z-index: 1300 !important;

	input[type='file'] {
		display: none;
	}

	.wrap-title {
		display: flex;
		justify-content: space-between;
		padding-bottom: 20px;
	}
	.have-account {
		min-width: 195px;
		font-style: normal;
		font-weight: 400;
		font-size: 14px !important;
		line-height: 20px;
		display: flex;
		align-items: center;
		text-align: center;
		letter-spacing: 0.2px;
		color: ${({ theme }) => theme.palette.content.veryDark};
		.sign-in-here {
			margin-left: 5px;
			font-weight: 600;
			color: rgb(44, 110, 238);
			cursor: pointer;
		}

		${({ theme }) => theme.breakpoints.up('sm')} {
			justify-content: flex-end;
		}
	}
	.title .MuiTypography-body1 {
		font-size: 20px;
		font-style: normal;
		font-weight: 800;
		line-height: 28px;
		color: ${({ theme }) => theme.colors.primary.main};
	}
`
